"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ProductDetailContext = _interopRequireDefault(require("../../../../ProductDetail/context/ProductDetailContext"));
var _ShopContext = _interopRequireDefault(require("../../../../context/ShopContext"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../../locals/it.json"));
var _Price = _interopRequireDefault(require("./Price.styles"));
var _formatPrice = _interopRequireDefault(require("../../../../utils/formatPrice"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Price = _ref => {
  let {
    lang
  } = _ref;
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    currency,
    locale = "de-DE"
  } = shopData || {};
  const {
    isoCode
  } = currency || {};
  const {
    productDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const {
    price = {}
  } = productDetailData || {};
  const {
    amount
  } = price || {};
  const css = (0, _Price.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  if (!amount) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.price, "mco-shop-voucher-selection-price")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.label, "mco-shop-voucher-selection-price__label")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.productDetail.labels.voucherValue",
    l: l
  }), ":"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.value, "mco-shop-voucher-selection-price__value")
  }, (0, _formatPrice.default)(amount, isoCode, locale)));
};
var _default = exports.default = Price;